import { render, staticRenderFns } from "./negotiationRemark.vue?vue&type=template&id=2dffe526&scoped=true"
import script from "./negotiationRemark.vue?vue&type=script&lang=js"
export * from "./negotiationRemark.vue?vue&type=script&lang=js"
import style0 from "./negotiationRemark.vue?vue&type=style&index=0&id=2dffe526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dffe526",
  null
  
)

export default component.exports